// removed by extract-text-webpack-plugin
module.exports = {"Form_wrap":"CreateChild__Form_wrap__3GTIa","Form_group":"CreateChild__Form_group__37GB-","ContainerBtn":"CreateChild__ContainerBtn__3rSGs","Btn":"CreateChild__Btn__1KQxY","RedBtn":"CreateChild__RedBtn__1Hmsm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChildController/CreateChild/CreateChild.css
// module id = 99
// module chunks = 0